<div class="tp-container">
  <div class="tp-header">
    <div class="tp-time-display">
      <span class="tp-time">{{ selectedSlot ? selectedSlot.label : '-- : -- --' }}</span>
    </div>
  </div>
  <div class="tp-search-wrap">
    <input type="text"
           class="tp-search"
           placeholder="Search time (e.g. 12:00 pm)"
           [(ngModel)]="searchQuery"
           (ngModelChange)="onSearchInput()"
           autocomplete="off">
  </div>
  <div class="tp-instructions">
    {{ instructionsText }}
  </div>
  <div class="tp-slots-wrap">
    <div *ngFor="let slot of availableSlots"
         class="tp-slot"
         [class.active]="selectedSlot === slot"
         (click)="onSlotClick(slot)">
      {{ slot.label }}
    </div>
    <div *ngIf="availableSlots.length === 0" class="tp-no-results">
      {{ searchQuery ? 'No matching available times' : 'No available times' }}
    </div>
  </div>
</div>
